import * as React from "react";
import { forwardRef } from "react";
const SvgInteraction = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m13.016 0-.914.935 2.784 2.784H1.189v1.3h13.7l-2.783 2.785.914.935 3.9-3.9.467-.467-.467-.467ZM4.969 9.1l-3.9 3.9-.467.467.467.467 3.9 3.9.915-.935-2.785-2.78h13.7v-1.3h-13.7l2.784-2.78Z", className: "s0789eb54d00e5af397caf9e522c4b5cc__b" }));
const ForwardRef = forwardRef(SvgInteraction);
export { ForwardRef as ReactComponent };
